import { css } from 'linaria';
import { styled } from 'linaria/react';

const mediaDesktop = '@media screen and (min-width: 1024px)';
const mediaSmallDesk = '@media screen and (min-width: 1024px) and (max-width: 1199px)';
const mediaTablet = '@media screen and (min-width: 768px) and (max-width: 1023px)';
const mediaMobile = '@media screen and (max-width: 767px)';

export namespace Containers {
  export const AddToLists = styled.div`
    display: flex;
    flex-direction: row;
    gap: var(--space-150);
    padding: var(--space-100) 0;
  `;

  export const MediaContent = styled.div`
    display: block;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 750px;
    grid-area: img;
    box-sizing: border-box;
    padding-right: var(--space-625);

    ${mediaSmallDesk} {
      flex-basis: 560px;
      padding-right: var(--space-500);
    }

    ${mediaTablet} {
      padding: 0;
    }

    ${mediaMobile} {
      padding: 0;
    }
  `;

  export const ProductInfo = styled.div`
    display: block;
    top: 24px;
    background-color: var(--background-primary);
    box-shadow: var(--box-shadow-m);
    border-radius: var(--space-100);
    z-index: 2;
    height: fit-content;
    width: 422px;
    grid-area: info;
    box-sizing: border-box;

    ${mediaDesktop} {
      max-width: 430px;
      padding: var(--space-300);
    }

    ${mediaSmallDesk} {
      flex-basis: 380px;
      max-width: 380px;
      padding: var(--space-300);
    }

    ${mediaTablet} {
      width: 100%;
      margin-top: var(--space-200);
      box-shadow: none;
    }

    ${mediaMobile} {
      width: 100%;
      padding-top: var(--space-200);
      box-shadow: none;
    }
  `;

  export const ReviewsScore = styled.div`
    padding: var(--space-100) 0;
  `;

  export const ProductVariants = styled.div`
    padding: var(--space-150) 0;
  `;

  export const AvailabilityMark = styled.div`
    margin-top: var(--space-200);
  `;

  export const DeliveryMethods = styled.div`
    margin: var(--space-200) 0 0 0;
  `;

  export const OnlineOrderOnly = styled.div`
    &:empty {
      display: none;
    }
    margin-top: var(--space-175);
    margin-bottom: 0;
  `;

  export const SkeletonRows = styled.div`
    display: flex;
    flex-direction: column;
  `;
}

export const sticky = css`
  position: sticky;
`;

export const reviewsSkeleton = css`
  margin-top: var(--space-25);
  margin-bottom: var(--space-50);
  border-radius: var(--rounding-l);
  width: 184px;
  height: var(--space-250);
`;

export const variantsSkeleton = css`
  border-radius: var(--rounding-l);
  width: 284px;
  height: var(--space-650);
`;

export const setOfStock = css`
  margin-top: var(--space-200);
`;
